import { apiEmpleo } from "../../util/ApiEmpleo";
import { VALORACION_SIN_VALORAR } from "../../util/defaults/valoracion";

/**
 * Takes the valuation id out of the POST response. CoreV2 usually returns
 * `id`, but a JSON-LD response may only carry `@id` (`/api/valoraciones/{id}`).
 */
const getCreatedValuationId = (res: any): string | null => {
  if (res?.id) {
    return `${res.id}`;
  }

  if (typeof res?.["@id"] === "string") {
    const id = res["@id"].split("/").filter(Boolean).pop();
    if (id) {
      return id;
    }
  }

  return null;
};

/**
 * Adds an employee to a contract as a new "Sin Valorar" valuation, the same
 * request the "Añadir a Contrato" button sends for recommendations. Returns the
 * id of the created valuation.
 */
export const apiCreateContractValuation = async (
  contractId: string,
  candidateId: string
): Promise<string> => {
  const res = await apiEmpleo.post("valoraciones", {
    Estado_en_proceso: VALORACION_SIN_VALORAR,
    contrato: `/api/contratos/${contractId}`,
    candidato: `/api/candidatos/${candidateId}`,
  });

  const valuationId = getCreatedValuationId(res);
  if (!valuationId) {
    throw new Error(
      `Valuation created for candidate ${candidateId} without id in the response`
    );
  }

  return valuationId;
};
